<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="24">
        <p>Agrega atributos a tener en cuenta para generar variaciones a este producto</p>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="10">
        <el-select v-model="attribute" placeholder="Agregar atributo" size="small">
          <el-option
            v-for="item in attributes"
            :key="item.id"
            :label="item.value_admin"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-button
          size="small" type="primary" icon="el-icon-plus"
          @click="addTab(attribute)">
          Agregar
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="mt-15">
      <el-col :span="24">
        <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab">
          <el-tab-pane v-for="(item) in editableTabs"
            :key="item.id"
            :label="item.title"
            :name="item.name">
            <terms-component :attribute="item" @changeTerms="updateTerms"/>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import { mapMutations, mapGetters } from 'vuex'
  import TermsComponent from './Terms.vue'
  import { getByKey } from '@/api/administration/adminTable.js'
  export default {
    components: { TermsComponent },
    data() {
      return {
        editableTabsValue: '',
        editableTabs: [],
        attribute: null,
        attributes: [],
        tabIndex: 0,
      }
    },
    computed: {
      ...mapGetters(['product']),
      terms:{
        get() { return this.product.terms },
        set(value) { this['product/SET_TERMS'](value) }
      }
    },
    watch: {
      '$route' (to, from) {
        this.updateTerms(null)
      }
    },
    created(){
      this.getAttributes()
    },
    methods: {
      ...mapMutations(['product/SET_TERMS']),
      updateTerms({id, title}, selected){
        console.log();
        this.terms = {id, title, terms: selected}
      },
      addTab(targetName) {
        targetName = this.attributes.find(element => element.id == targetName)
        let newTabName = ++this.tabIndex + '';
        this.editableTabs.push({
          id: targetName.id,
          title: targetName.value_admin,
          name: newTabName,
        });
        this.editableTabsValue = newTabName;
        this.attribute = null
      },
      removeTab(targetName) {
         this.$confirm('Confirmar eliminación de atributo', 'Warning', {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }).then(() => {
          let item = this.editableTabs[targetName-1];
          this.updateTerms({id: item.id, title: item.title}, null)
          let tabs = this.editableTabs;
          let activeName = this.editableTabsValue;
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }
          
          this.editableTabsValue = activeName;
          this.editableTabs = tabs.filter(tab => tab.name !== targetName);
        }).catch(() => {
          return null         
        });
      },
      async getAttributes(){ 
        let data = await getByKey('attributes')
        this.attributes = data.data
      }
    }
  }
</script>